var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"footsd",staticClass:"meetFooter reds"},[_c('a',{attrs:{"href":_vm.footInfo.LogoLink}},[_c('img',{staticClass:"wqzhlogo",attrs:{"src":_vm.footInfo.LogoImg,"alt":""}})]),_vm._v("\n\t"+_vm._s(_vm.footInfo.LogoTxt)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }